var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button-group',{staticClass:"float-right"},[(_vm.$temAcessoView('APPSE-FORN-PAG-01'))?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.confirmarNovoPagamento()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Novo Registro de Pagamento")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }